const { vehicleReqDate, routeShortForm, routeDetails } = require('../../utils');

module.exports = [
  {
    id: 1,
    key: 'indent_id',
    label: 'INDENT ID',
    css_class: 'order-id',
    data: {
      key: 'order_number',
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'shipment_number',
      },
      truncate_on: 20,
    },
  },
  {
    id: 2,
    label: 'STATUS',
    css_class: 'order-status',
    data: {
      key: 'status',
    },
    truncate_on: 20,
  },
  {
    id: 3,
    label: 'ROUTE',
    css_class: 'order-route',
    data: {
      key: 'route_location',
      view_rule: routeLocation => routeShortForm(routeLocation),
    },
    expanded_text: {
      data: {
        key: 'route_location',
        view_rule: routeLocation => routeDetails(routeLocation),
      },
    },
    truncate_on: 20,
  },
  {
    id: 4,
    label: 'TRANSPORTER',
    css_class: 'order-vendor',
    data: {
      key: 'transporter_name',
    },
    truncate_on: 16,
  },
  {
    id: 5,
    label: 'VEHICLE TYPE',
    css_class: 'order-truck',
    data: {
      key: 'vehicle_type_name',
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'sources',
        view_rule: (sources, format = 'DD MMM YYYY | hh:mm A') => vehicleReqDate(sources, format),
      },
      truncate_on: 24,
    },
  },
];
